import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iFrameTitle", "name", "videoId"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import PropTypes from 'prop-types';
import React from 'react';
import { IFRAME_AVAILABLE_FEATURES, IFRAME_DEFAULT_TITLE } from "./constants";
import { useMainContext } from "../main-context";
import { EmbedContainer } from "./videoask-player.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var VideoAskPlayer = function VideoAskPlayer(_ref) {
  var iFrameTitle = _ref.iFrameTitle,
    name = _ref.name,
    videoId = _ref.videoId,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useMainContext = useMainContext(),
    sharedVariables = _useMainContext.sharedVariables;
  return /*#__PURE__*/_jsx(EmbedContainer, _objectSpread(_objectSpread({}, rest), {}, {
    children: /*#__PURE__*/_jsx("iframe", {
      allow: IFRAME_AVAILABLE_FEATURES.join(' *;'),
      src: "https://www.".concat(sharedVariables.VIDEOASK_ROOT_DOMAIN, "/").concat(videoId),
      title: name || iFrameTitle || IFRAME_DEFAULT_TITLE
    })
  }));
};
VideoAskPlayer.propTypes = {
  aspectRatio: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired
  }),
  iFrameTitle: PropTypes.string,
  name: PropTypes.string,
  videoId: PropTypes.string.isRequired
};
VideoAskPlayer.defaultProps = {
  aspectRatio: {
    x: 4,
    y: 3
  },
  iFrameTitle: null,
  name: null
};
VideoAskPlayer.displayName = 'VideoAskPlayer';
export default VideoAskPlayer;